/*
 * @Author: Czy
 * @Date: 2026-03-03
 * @FilePath: /ayh-mobile-overseas/src/store/language.ts
 */
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { LanguageSelectorVo } from '@/service/user/user.d'

export const useLanguageStore = defineStore(
  'language',
  () => {
    // 当前选中的语言信息
    const currentLanguage = ref<LanguageSelectorVo | null>(null)

    const setLanguage = (lang: LanguageSelectorVo) => {
      currentLanguage.value = lang
    }

    const clearLanguage = () => {
      currentLanguage.value = null
    }

    // 货币符号，如 ¥、$、€，fallback 为 $
    const currencySymbol = computed(() => currentLanguage.value?.currencySymbol || '$')

    // 货币代码，如 CNY、USD，fallback 为 USD
    const currencyCode = computed(() => currentLanguage.value?.currency || 'USD')

    return {
      currentLanguage,
      setLanguage,
      clearLanguage,
      currencySymbol,
      currencyCode,
    }
  },
  {
    persist: true,
  },
)
